import ResponsiveImage from "../../atoms/image/ResponsiveImage";

export default function People({ className }) {
  return (
    <section className={className}>
      <ResponsiveImage
        width="1440"
        height="280"
        mobile="crop"
        imgClass="md:w-100 img-fit"
        wrapClass="lg:maxw-3xl mx-auto"
        src="https://assets.setmore.com/website/v2/images/common-images/setmore-people-community"
        alt="Community group of Setmore customers"
      />
    </section>
  );
}
